/*eslint-env node*/
const ensureString = (envVariable?: string) => {
    return envVariable || '';
};

/* Build information */
export const country = ensureString(process.env.REACT_APP_COUNTRY);
export const language = ensureString(process.env.REACT_APP_LANGUAGE);
export const locale = language + '-' + country.toUpperCase();
export const env = ensureString(process.env.ENV || process.env.NODE_ENV);
export const version = (process.env.VERSION || 'unknown')
    .split('/')
    .pop() as string;
export const publicUrl = ensureString(process.env.PUBLIC_URL);
const favouriteBaseName = country === 'us' ? 'favorites' : 'favourites';
export const favouritesUrl = `${process.env.REACT_APP_LANDING_PAGE_DOMAIN}/${process.env.REACT_APP_COUNTRY}/${process.env.REACT_APP_LANGUAGE}/${favouriteBaseName}/`;

/* Endpoints and credentials */
export const listClientId = ensureString(process.env.LIST_CLIENT_ID);
export const listEndpoint = ensureString(process.env.LIST_ENDPOINT);

/* Sentry */
const sentryDsn = ensureString(process.env.SENTRY_DSN);

export const [, sentryKey = ''] = sentryDsn.match(/:\/\/(.*?)@/) || [];
export const [, sentryProject = ''] =
    sentryDsn.match(/@.*sentry.io\/(.*)/) || [];
export const sentryClient = 'ikea.sentry.register';

const a2 = document.createElement('a');
a2.href = publicUrl + 'agent/';
// agent path will be something like /se/sv/list/agent
export const agentPath = a2.pathname;

export const cacheTime = 10 * 60 * 1000; // 10 minutes in milllisecods

export const allowCookies = () =>
    window.ikea?.cookieConsent ? window.ikea.cookieConsent.hasConsent(2) : true; // Allow cookies for markets that don't have ikea.cookieConsent

export const environment: 'staging' | 'production' =
    env === 'production' ? 'production' : 'staging';

/* Optimizely */
export const optimizelySDKKey: string | undefined =
    process.env.OPTIMIZELY_SDK_KEY;
